import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { IssueReportGet } from "../../../models/IssueReport"
import { useHashTab } from "../../../../hooks/useHashTab"
import { IssueReportDetails } from "./details_tab/IssueReportDetails"

const returnURL = "/issue-reports"

export function IssueReportContainer() {
  const { issueReportId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [issueReport, setIssueReport] = useState<IssueReportGet>()

  useEffect(() => {
    if (issueReportId) {
      digitalManagerApi
        .get<IssueReportGet>(`/issueReports/${issueReportId}`)
        .then((res) => {
          setIssueReport(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [issueReportId, navigate])

  if (!issueReportId) {
    return <Navigate to={returnURL} />
  }

  if (!issueReport) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: issueReport.subject,
    label: "Issue Report ID",
    subtitle: issueReport.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && <IssueReportDetails issueReport={issueReport} />}
    </div>
  )
}
